import CommonModal from "../../../../../Component/Ui-Kits/Modal/Common/CommonModal";
import EmployeeProbationForm from "../form/EmployeeProbationForm";
import { IEmployeeUnderProbationList } from "../../../../../Api/Services/HRService";
import { useModalSelector } from "../../../../../hooks/useModalSelector";

const UpdateProbationModal = ({
  handleToggle,
  selectedUser,
  setSelectedUser,
}: {
  handleToggle: () => void;
  setSelectedUser?: any;
  selectedUser: IEmployeeUnderProbationList;
}) => {
  const { isOpen } = useModalSelector();
  return (
    <CommonModal
      centered
      size="xl"
      isOpen={isOpen}
      showFooter={false}
      titleClassName="text-white"
      headerClassName="bg-primary"
      modalBodyClassName="ps-lg-4"
      title={`Update Probation - ${selectedUser?.emp_code}`}
      toggle={handleToggle}
    >
      <div className="modal-toggle-wrapper">
        <EmployeeProbationForm
          onClose={handleToggle}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
        />
      </div>
    </CommonModal>
  );
};

export default UpdateProbationModal;
